import { render, staticRenderFns } from "./InTeamTab.vue?vue&type=template&id=040c3f7f"
import script from "./InTeamTab.vue?vue&type=script&lang=js"
export * from "./InTeamTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports